// extracted by mini-css-extract-plugin
module.exports = {"root":"FlowAndSeqGetStarted_root__3Q8G7","message":"FlowAndSeqGetStarted_message__I__b5"};